import React, { useCallback, useEffect } from "react";
import { capitalize } from "lodash";

import { useBuildUrl } from "routes/hooks";

import useCurrentUser from "data/advisor/useCurrentUser";
import useRedirect from "data/hub/hooks";

import Loading from "components/Loading";

import { IFrameForm } from "..";
import { useWelcomeToHublyFeature } from "../hooks";

function CommunityForm() {
  const user = useCurrentUser();
  const buildUrl = useBuildUrl();
  const redirect = useRedirect();
  const { loadingFeature, welcomeForm } = useWelcomeToHublyFeature();

  const redirectToBookingCall = useCallback(() => {
    redirect("welcome/booking");
  }, [redirect]);

  useEffect(() => {
    if (!loadingFeature && !welcomeForm?.formUrl) redirectToBookingCall();
  }, [redirectToBookingCall, loadingFeature, welcomeForm]);

  if (loadingFeature || !welcomeForm?.formUrl)
    return (
      <Loading
        active
        messages={[
          "Welcome to Hubly!",
          "We're getting everything ready to know more about you",
        ]}
      />
    );

  return (
    <IFrameForm
      formUrl={buildUrl(welcomeForm?.formUrl, [
        ["firstname", user?.firstName],
        ["lastname", user?.lastName],
        ["email", user?.email],
        ["crm", capitalize(user.integrations?.[0]?.type)],
      ])}
      title="Community Form"
      dismissMessage={welcomeForm?.dismissMessage}
      onDismiss={redirectToBookingCall}
      validator={welcomeForm?.validator}
    />
  );
}

export default CommunityForm;
